import React, { useState } from 'react';
import { Card, Table, Tag, Typography, Button, Space, Drawer, Form, Input, InputNumber, message, Modal, Row, Col, Radio, Checkbox } from 'antd';
import { PlusOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

// TODO: 联调时替换为 PaaS 接口
const REGIONS = [
    { key: 'domestic', label: '国内' },
    { key: 'asiaPacific', label: '亚太' },
    { key: 'northAmerica', label: '北美' },
    { key: 'europe', label: '欧洲' },
];

// TODO: 联调时替换为接口数据
const MOCK_MODELS = [
    { key: '1', provider: 'deepseek', name: 'v4-flash', apiUrl: 'https://api.deepseek.com/v1',
        inputPrice: 0.001, outputPrice: 0.004,
        regions: ['domestic', 'northAmerica'],
        keys: [
            { keyName: '主Key', keyValue: 'sk-test-ds-flash-main', isDefault: true, todayCalls: 1250, successRate: 99.2, status: 'normal' },
            { keyName: '备用Key', keyValue: 'sk-test-ds-flash-bak', isDefault: false, todayCalls: 320, successRate: 98.5, status: 'normal' },
        ],
    },
    { key: '2', provider: 'deepseek', name: 'pro', apiUrl: 'https://api.deepseek.com/v1',
        inputPrice: 0.004, outputPrice: 0.016,
        regions: ['domestic'],
        keys: [
            { keyName: '主Key', keyValue: 'sk-test-ds-pro-main', isDefault: true, todayCalls: 890, successRate: 99.5, status: 'normal' },
        ],
    },
    { key: '3', provider: 'doubao', name: 'vision-1.8', apiUrl: 'https://ark.cn-beijing.volces.com/api/v3',
        inputPrice: 0.003, outputPrice: 0.012,
        regions: ['domestic'],
        keys: [
            { keyName: '主Key', keyValue: 'sk-test-db-v18-main', isDefault: true, todayCalls: 560, successRate: 98.8, status: 'normal' },
            { keyName: '备用Key', keyValue: 'sk-test-db-v18-bak', isDefault: false, todayCalls: 200, successRate: 96.5, status: 'error' },
        ],
    },
    { key: '4', provider: 'doubao', name: 'text-1.8', apiUrl: 'https://ark.cn-beijing.volces.com/api/v3',
        inputPrice: 0.002, outputPrice: 0.008,
        regions: ['domestic'],
        keys: [
            { keyName: '主Key', keyValue: 'sk-test-db-t18-main', isDefault: true, todayCalls: 410, successRate: 99.0, status: 'normal' },
        ],
    },
];

const ModelManage = () => {
    const [models, setModels] = useState(MOCK_MODELS);
    const [formDrawer, setFormDrawer] = useState({ open: false, editing: null });
    const [detailDrawer, setDetailDrawer] = useState({ open: false, model: null });
    const [localKeys, setLocalKeys] = useState([]);
    const [form] = Form.useForm();
    // 新建/编辑时选中的区域
    const [checkedRegions, setCheckedRegions] = useState({});

    // ---------- 获取区域标签 ----------
    const getRegionLabel = (key) => REGIONS.find(r => r.key === key)?.label || key;

    const initCheckedRegions = (model) => {
        const ck = {};
        REGIONS.forEach(r => {
            ck[r.key] = model?.regions?.includes(r.key) || false;
        });
        setCheckedRegions(ck);
    };

    const handleOpenDetail = (record) => {
        setLocalKeys(JSON.parse(JSON.stringify(record.keys)));
        setDetailDrawer({ open: true, model: record });
    };
    const handleAddLocalKey = () => {
        setLocalKeys(prev => [...prev, { keyName: '', keyValue: '', isDefault: false, todayCalls: 0, successRate: 100, status: 'normal' }]);
    };
    const handleEditLocalKey = (idx, field, value) => {
        setLocalKeys(prev => prev.map((k, i) => i === idx ? { ...k, [field]: value } : k));
    };
    const handleSetLocalDefault = (keyName) => {
        setLocalKeys(prev => prev.map(k => ({ ...k, isDefault: k.keyName === keyName })));
    };
    const handleDeleteLocalKey = (keyName, isDefault) => {
        if (isDefault) { message.warning('默认 Key 不可删除'); return; }
        setLocalKeys(prev => prev.filter(k => k.keyName !== keyName));
    };
    const handleSaveKeys = () => {
        const hasEmpty = localKeys.some(k => !k.keyName.trim() || !k.keyValue.trim());
        if (hasEmpty) { message.warning('请填写完整的 Key 名称和 Key 值'); return; }
        setModels(prev => prev.map(m => m.key === detailDrawer.model.key ? { ...m, keys: localKeys } : m));
        message.success('API Key 配置已保存');
        setDetailDrawer({ open: false, model: null });
    };

    const handleOpenNew = () => {
        form.resetFields();
        initCheckedRegions(null);
        setFormDrawer({ open: true, editing: null });
    };
    const handleOpenEdit = (record) => {
        form.setFieldsValue({
            provider: record.provider, name: record.name,
            apiUrl: record.apiUrl,
            inputPrice: record.inputPrice, outputPrice: record.outputPrice,
        });
        initCheckedRegions(record);
        setFormDrawer({ open: true, editing: record });
    };

    const handleFormSubmit = () => {
        form.validateFields().then(values => {
            const selected = REGIONS.filter(r => checkedRegions[r.key]).map(r => r.key);
            if (selected.length === 0) { message.warning('至少勾选一个服务区域'); return; }
            const base = {
                provider: values.provider, name: values.name,
                apiUrl: (values.apiUrl || '').trim(),
                inputPrice: values.inputPrice, outputPrice: values.outputPrice,
                regions: selected,
            };
            if (formDrawer.editing) {
                setModels(prev => prev.map(m => m.key === formDrawer.editing.key ? { ...m, ...base, keys: m.keys } : m));
                message.success('模型已更新');
            } else {
                setModels(prev => [...prev, { key: Date.now().toString(), ...base, keys: [] }]);
                message.success('模型已创建');
            }
            setFormDrawer({ open: false, editing: null }); form.resetFields();
        }).catch(() => {});
    };

    const handleDeleteModel = (record) => {
        Modal.confirm({ title: '删除模型', content: `确定删除模型「${record.name}」？`, okType: 'danger',
            onOk: () => setModels(prev => prev.filter(m => m.key !== record.key)) });
    };

    const columns = [
        { title: 'API Provider', dataIndex: 'provider', width: 110,
            render: (v) => <Tag color="blue" style={{ border: 'none', fontSize: 12 }}>{v}</Tag> },
        { title: 'Model', dataIndex: 'name', width: 130, render: (v) => <Text style={{ fontFamily: 'monospace' }}>{v}</Text> },
        { title: '服务区域', key: 'serviceRegions', width: 280,
            render: (_, r) => {
                if (!r.regions || r.regions.length === 0) return <span style={{ color: '#ccc' }}>--</span>;
                return (
                    <div>
                        <div style={{ marginBottom: 2 }}>
                            {r.regions.map((rk) => (
                                <Tag key={rk} color="green" style={{ border: 'none', marginRight: 4, marginBottom: 2, fontSize: 11 }}>{getRegionLabel(rk)}</Tag>
                            ))}
                        </div>
                        <Text style={{ fontSize: 11, fontFamily: 'monospace' }} copyable={{ text: r.apiUrl }}>{r.apiUrl}</Text>
                    </div>
                );
            },
        },
        { title: '输入（元/百万token）', key: 'inputPrice', width: 150, align: 'center',
            render: (_, r) => r.inputPrice != null ? <Text style={{ fontSize: 12 }}>¥ {Number(r.inputPrice).toFixed(4)}</Text> : <span style={{ color: '#ccc' }}>--</span> },
        { title: '输出（元/百万token）', key: 'outputPrice', width: 150, align: 'center',
            render: (_, r) => r.outputPrice != null ? <Text style={{ fontSize: 12 }}>¥ {Number(r.outputPrice).toFixed(4)}</Text> : <span style={{ color: '#ccc' }}>--</span> },
        { title: 'API Key', key: 'keys', width: 80, align: 'center', render: (_, r) => r.keys.length },
        { title: '操作', key: 'action', width: 200,
            render: (_, r) => (
                <Space size={4}>
                    <Button type="link" size="small" onClick={() => handleOpenDetail(r)}>配置API Key</Button>
                    <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleOpenEdit(r)}>编辑</Button>
                    <Button type="link" size="small" danger icon={<DeleteOutlined />} onClick={() => handleDeleteModel(r)}>删除</Button>
                </Space>
            ),
        },
    ];

    const localKeyColumns = [
        { title: 'Key 名称', dataIndex: 'keyName', width: 140,
            render: (v, r, idx) => <Input size="small" value={v} onChange={(e) => handleEditLocalKey(idx, 'keyName', e.target.value)} placeholder="Key名称" /> },
        { title: 'Key 值', dataIndex: 'keyValue', width: 220,
            render: (v, r, idx) => <Input size="small" value={v} onChange={(e) => handleEditLocalKey(idx, 'keyValue', e.target.value)} placeholder="sk-xxx..." /> },
        { title: '默认', dataIndex: 'isDefault', width: 55, align: 'center',
            render: (v, r) => <Radio checked={v} onChange={() => handleSetLocalDefault(r.keyName)} /> },
        { title: '调用', dataIndex: 'todayCalls', width: 70, align: 'center', render: (v) => v.toLocaleString() },
        { title: '成功率', dataIndex: 'successRate', width: 70, align: 'center',
            render: (v) => <Text style={{ color: v >= 98 ? '#52c41a' : '#ff4d4f' }}>{v}%</Text> },
        { title: '', key: 'op', width: 50,
            render: (_, r) => <Button type="link" size="small" danger onClick={() => handleDeleteLocalKey(r.keyName, r.isDefault)}>删除</Button> },
    ];

    return (
        <div style={{ padding: 24 }}>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: 0 }}>模型管理</Title>
                <Button type="primary" icon={<PlusOutlined />} onClick={handleOpenNew}>新建模型</Button>
            </div>
            <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
                <Table columns={columns} dataSource={models} rowKey="key"
                    pagination={{ showSizeChanger: true, showTotal: (t) => `共 ${t} 个模型` }}
                    scroll={{ x: 1100 }} />
            </Card>

            {/* ===== API Key 抽屉 ===== */}
            <Drawer title={`配置API Key — ${detailDrawer.model?.name || ''}`} open={detailDrawer.open}
                onClose={() => setDetailDrawer({ open: false, model: null })} width={780}
                footer={<div style={{ textAlign: 'right' }}><Button onClick={() => setDetailDrawer({ open: false, model: null })} style={{ marginRight: 8 }}>取消</Button><Button type="primary" onClick={handleSaveKeys}>保存</Button></div>}>
                {detailDrawer.model && (
                    <>
                        <Card bordered={false} style={{ borderRadius: 8, marginBottom: 16, background: '#fafafa' }}>
                            <Row gutter={16}>
                                <Col span={6}><Text type="secondary" style={{ fontSize: 12 }}>API Provider</Text><div><Tag color="blue" style={{ border: 'none', marginTop: 4 }}>{detailDrawer.model.provider}</Tag></div></Col>
                                <Col span={6}><Text type="secondary" style={{ fontSize: 12 }}>Model</Text><div><Text strong style={{ fontSize: 15, fontFamily: 'monospace' }}>{detailDrawer.model.name}</Text></div></Col>
                                <Col span={12}><Text type="secondary" style={{ fontSize: 12 }}>服务区域</Text><div>
                                    {detailDrawer.model.regions?.map(rk => (
                                        <Tag key={rk} color="green" style={{ border: 'none', marginTop: 4, marginRight: 4 }}>{getRegionLabel(rk)}</Tag>
                                    )) || <span style={{ color: '#ccc' }}>--</span>}
                                </div></Col>
                            </Row>
                        </Card>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                            <Title level={5} style={{ margin: 0 }}>Key 管理</Title>
                            <Button size="small" icon={<PlusOutlined />} onClick={handleAddLocalKey}>添加 Key</Button>
                        </div>
                        {localKeys.length === 0 ? (
                            <div style={{ textAlign: 'center', padding: 40, background: '#fafafa', borderRadius: 8 }}>
                                <Text type="secondary">暂无 Key，点击"添加 Key"开始配置</Text>
                            </div>
                        ) : (
                            <Table dataSource={localKeys.map((k, i) => ({ ...k, key: i }))} size="small" pagination={false} columns={localKeyColumns} />
                        )}
                    </>
                )}
            </Drawer>

            {/* ===== 新建/编辑模型抽屉 ===== */}
            <Drawer title={formDrawer.editing ? '编辑模型' : '新建模型'} open={formDrawer.open}
                onClose={() => { setFormDrawer({ open: false, editing: null }); form.resetFields(); }} width={520}
                footer={<div style={{ textAlign: 'right' }}><Button onClick={() => { setFormDrawer({ open: false, editing: null }); form.resetFields(); }} style={{ marginRight: 8 }}>取消</Button><Button type="primary" onClick={handleFormSubmit}>保存</Button></div>}>
                <Form form={form} layout="vertical">
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item name="provider" label="API Provider" rules={[{ required: true, message: '请输入' }]}>
                                <Input placeholder="如：deepseek" />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="name" label="Model" rules={[{ required: true, message: '请输入' }]}>
                                <Input placeholder="如：v4-flash" />
                            </Form.Item>
                        </Col>
                    </Row>

                    {/* API 地址 */}
                    <Form.Item name="apiUrl" label="API 地址" rules={[{ required: true, message: '请输入' }]}>
                        <Input placeholder="如：https://api.deepseek.com/v1" />
                    </Form.Item>

                    {/* 服务区域：复选框 */}
                    <div style={{ marginBottom: 16 }}>
                        <Text strong style={{ fontSize: 14, display: 'block', marginBottom: 8 }}>服务区域</Text>
                        <Checkbox.Group
                            value={REGIONS.filter(r => checkedRegions[r.key]).map(r => r.key)}
                            onChange={(vals) => {
                                const ck = {};
                                REGIONS.forEach(r => { ck[r.key] = vals.includes(r.key); });
                                setCheckedRegions(ck);
                            }}
                        >
                            <Row>
                                {REGIONS.map(r => (
                                    <Col span={12} key={r.key}>
                                        <Checkbox value={r.key} style={{ marginBottom: 8 }}>{r.label}</Checkbox>
                                    </Col>
                                ))}
                            </Row>
                        </Checkbox.Group>
                        <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>
                            <span style={{ color: '#faad14' }}>⚠</span> 至少勾选一个服务区域
                        </Text>
                    </div>

                    {/* 价格 */}
                    <Form.Item label="输入/输出价格（元/百万token）" style={{ marginBottom: 12 }}>
                        <Row gutter={12}>
                            <Col span={12}>
                                <Form.Item name="inputPrice" rules={[{ required: true, message: '请输入' }]} initialValue={0.001} noStyle>
                                    <InputNumber min={0.0001} step={0.0001} precision={4} style={{ width: '100%' }} prefix="¥" placeholder="0.001" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="outputPrice" rules={[{ required: true, message: '请输入' }]} initialValue={0.004} noStyle>
                                    <InputNumber min={0.0001} step={0.0001} precision={4} style={{ width: '100%' }} prefix="¥" placeholder="0.004" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Text type="secondary" style={{ fontSize: 11, display: 'block', marginTop: 2 }}>输入 / 输出</Text>
                    </Form.Item>
                </Form>
            </Drawer>
        </div>
    );
};

export default ModelManage;
